import { render, staticRenderFns } from "./Timerule.vue?vue&type=template&id=47323464"
import script from "./Timerule.vue?vue&type=script&lang=js"
export * from "./Timerule.vue?vue&type=script&lang=js"
import style0 from "./Timerule.vue?vue&type=style&index=0&id=47323464&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports